define.alias("checkout/components/seamless-checkout-table/charges", "calendar/components/seamless-checkout-table/charges");